module.exports = __webpack_public_path__ + "img/logo10.84fc0c54.png";